import React from 'react'

const EnvironmentTag = ({ config }) => (
  <p
    className={`capitalize py-1 text-xs mr-4 rounded-full px-2 ${['staging', 'development'].includes(config.environment)
      ? 'bg-orange' : 'bg-gray'
      } inline - block`}
  >
    {config.environment}
  </p>
)

export default EnvironmentTag
